import { Mail, MapPin, Phone } from "lucide-react";

/**
 * Contact information sidebar component
 */
const ContactInfo = () => {
  const contactDetails = [
    {
      icon: Mail,
      label: "Email",
      value: "info@v1athletics.com",
      href: "mailto:info@v1athletics.com"
    },
    {
      icon: Phone,
      label: "Phone",
      value: "778 288 0857",
      href: "tel:+17782880857"
    },
    {
      icon: MapPin,
      label: "Location",
      value: "White Rock, BC\nCanada",
      href: null
    }
  ];

  return (
    <div className="lg:col-span-1">
      <div className="mb-12">
        <h3 className="text-xl font-bold text-white uppercase tracking-tight mb-6">
          Contact Information
        </h3>
        <div className="space-y-6">
          {contactDetails.map((detail) => (
            <div key={detail.label} className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#56C6C6]/10 flex items-center justify-center flex-shrink-0">
                <detail.icon className="w-5 h-5 text-[#56C6C6]" />
              </div>
              <div>
                <p className="text-zinc-400 text-sm uppercase tracking-wider mb-1">{detail.label}</p>
                {detail.href ? (
                  <a href={detail.href} className="text-white hover:text-[#56C6C6] transition-colors">
                    {detail.value}
                  </a>
                ) : (
                  <p className="text-white whitespace-pre-line">{detail.value}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
